import AddServiceReport from '@/Wist-blockchain/serviceReport/view/user/addServiceReport'
import { createFileRoute, redirect } from '@tanstack/react-router'

export const Route = createFileRoute(
  '/_authenticated/instruments/serviceReport/addServiceReport',
)({
  beforeLoad: ({ context }) => {
    if (!context.user) throw redirect({ to: '/login' })
    const { isServicioTecnico, isAdmin } = context.userRoles
    if (!isServicioTecnico && !isAdmin) throw redirect({ to: '/unauthorized' })
  },
  component: AddServiceReport,
})

// function RouteComponent() {
//   return (
//     <div>
//       Hello "/_authenticated/instruments/serviceReport/addServiceReport"!
//     </div>
//   )
// }
